import type { IconData } from '@stacksjs/iconify-core'

export const eco: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M389.053 126.3A302.9 302.9 0 0 0 280.012 18.15L272 13.516l-8.012 4.634A301.08 301.08 0 0 0 113.4 279.042c0 3.445.06 6.944.177 10.4c1.592 46.856 19.511 86.283 51.82 114.018c24.724 21.225 56.438 34.182 90.607 37.273V496h32V240H256v168.528c-54.064-6.263-107.873-44.455-110.444-120.174c-.106-3.095-.16-6.228-.16-9.312A270.29 270.29 0 0 1 272 50.673a270.29 270.29 0 0 1 126.6 228.369c0 3.084-.054 6.217-.16 9.313c-2.056 60.573-36.907 97.127-78.444 112.536v33.867a156.2 156.2 0 0 0 58.607-31.3c32.309-27.735 50.228-67.162 51.82-114.017c.117-3.456.177-6.955.177-10.4A300.95 300.95 0 0 0 389.053 126.3\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default eco
